import { defineMessages } from 'react-intl-next';

export const linkMessages = defineMessages({
	openLink: {
		id: 'fabric.editor.openLink',
		defaultMessage: 'Open link in a new tab',
		description: 'Opens the link in a new tab',
	},
	openPreviewPanel: {
		id: 'fabric.editor.openPreviewPanel',
		defaultMessage: 'Open preview panel',
		description: 'Opens preview panel and loads the page inside it',
	},
});
